import {
  ColdWaterMeterIcon,
  HeatMeterIcon,
  HotWaterMeterIcon,
  GasMeterIcon,
  ElectricityMeterIcon,
} from '../../assets/meters';
import { DSScaledColors } from '../../components-v4/theme';
import { MeterType } from '../../request-single-page-slice';

type MeterColorType = keyof DSScaledColors;

interface MeterReading {
  label: string | null;
}

interface MeterVariant {
  icon: any;
  color: MeterColorType;
  readings: MeterReading[];
  digitCapacity: number;
}

const singleReading: MeterReading[] = [{ label: null }];

export const MetersVariants: Record<MeterType, MeterVariant> = {
  ColdWaterAreaMeter: {
    icon: ColdWaterMeterIcon,
    color: 'primary' as const,
    readings: singleReading,
    digitCapacity: 99999,
  },
  HotWaterAreaMeter: {
    icon: HotWaterMeterIcon,
    color: 'red' as const,
    readings: singleReading,
    digitCapacity: 99999,
  },
  HeatAreaMeter: {
    icon: HeatMeterIcon,
    color: 'red' as const,
    readings: singleReading,
    digitCapacity: 99999.999,
  },
  HeatDistributorAreaMeter: {
    icon: HeatMeterIcon,
    color: 'red' as const,
    readings: singleReading,
    digitCapacity: 99999.999,
  },
  GasAreaMeter: {
    icon: GasMeterIcon,
    color: 'primary' as const,
    readings: singleReading,
    digitCapacity: 99999,
  },
  ElectricOneRateAreaMeter: {
    icon: ElectricityMeterIcon,
    color: 'orange' as const,
    readings: singleReading,
    digitCapacity: 99999,
  },
  ElectricTwoRateAreaMeter: {
    icon: ElectricityMeterIcon,
    color: 'orange' as const,
    readings: [{ label: 'День (Т1)' }, { label: 'Ночь (Т2)' }],
    digitCapacity: 99999,
  },
  ElectricThreeRateAreaMeter: {
    icon: ElectricityMeterIcon,
    color: 'orange' as const,
    readings: [
      { label: 'Пик (Т1)' },
      { label: 'Ночь (Т2)' },
      { label: 'Полупик (Т3)' },
    ],
    digitCapacity: 99999,
  },
};
